export default {
  AU: ['en-AU'],
  NZ: ['mi-NZ', 'en-NZ'],
  MY: ['en-MY', 'ms-MY', 'zh-MY', 'ta-MY'],
  SG: ['en-SG', 'zh-SG', 'zh-Hans-SG', 'ms-SG', 'ta-SG'],
  US: ['en-US', 'es-US', 'zh-US', 'fr-US'],
  GB: ['en-GB', 'cy-GB'],
  CA: ['en-CA', 'fr-CA', 'zh-CA'],
  CN: ['zh-CN', 'zh-Hans-CN'],
  TW: ['zh-TW', 'zh-Hant-TW'],
  HK: ['zh-HK', 'zh-Hant-HK', 'en-HK'],
  IN: ['en-IN', 'hi-IN', 'ta-IN', 'te-IN', 'bn-IN', 'mr-IN'],
  JP: ['ja-JP'],
  KR: ['ko-KR'],
  ID: ['id-ID'],
  TH: ['th-TH'],
  VN: ['vi-VN'],
  PH: ['en-PH', 'tl-PH'],
  FR: ['fr-FR'],
  DE: ['de-DE'],
  ES: ['es-ES', 'ca-ES', 'eu-ES', 'gl-ES'],
  IT: ['it-IT'],
  PT: ['pt-PT'],
  BR: ['pt-BR'],
  MX: ['es-MX'],
  RU: ['ru-RU'],
  SA: ['ar-SA'],
  AE: ['ar-AE'],
  ZA: ['en-ZA', 'af-ZA']
}
